import offerOverlayLink from './offerOverlayLink';

export default offerOverlayLink;
